import { render, staticRenderFns } from "./sceneMarketing.vue?vue&type=template&id=b44067d8&scoped=true&"
import script from "./sceneMarketing.vue?vue&type=script&lang=js&"
export * from "./sceneMarketing.vue?vue&type=script&lang=js&"
import style0 from "./sceneMarketing.vue?vue&type=style&index=0&id=b44067d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44067d8",
  null
  
)

export default component.exports